@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

class MobileUpdateConfigDto(
    val isEnabled: Boolean,
    val ignoreLastMinorVersion: Boolean,
    val android: MobileUpdatePlatformConfigDto,
    val ios: MobileUpdatePlatformConfigDto,
    val statsUrl: String?,
)

class MobileUpdatePlatformConfigDto(
    val isForceUpdateRequiredEnabled: Boolean,
    val minVersionForForceUpdate: String,
    val isForcedUpdateInBackground: Boolean,
    val isForcedUpdateOptional: Boolean,
)
